import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-7" }
const _hoisted_5 = { style: {"font-size":"2em","font-weight":"300","color":"#33475b"} }
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "col-lg-5 col-sm-6 text-right" }
const _hoisted_9 = {
  key: 0,
  href: `/#/admin/organizations/manage`,
  role: "button",
  class: "btn btn-success text-white",
  style: {"padding":"0.7em 2em"}
}
const _hoisted_10 = { class: "container" }
const _hoisted_11 = {
  class: "form-group",
  style: {"margin-bottom":"40px"}
}
const _hoisted_12 = { class: "input-group mb-3" }
const _hoisted_13 = { class: "input-group-append" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  class: "row",
  style: {"margin-bottom":"40px"}
}
const _hoisted_16 = { class: "col-sm-7" }
const _hoisted_17 = { class: "card bg-light" }
const _hoisted_18 = { class: "card-body" }
const _hoisted_19 = { class: "card-title" }
const _hoisted_20 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_21 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_22 = { class: "card-text" }
const _hoisted_23 = ["href"]
const _hoisted_24 = ["href"]
const _hoisted_25 = ["href"]
const _hoisted_26 = { class: "col-sm-5" }
const _hoisted_27 = { class: "table table-sm table-striped" }
const _hoisted_28 = {
  class: "fg-color-blue",
  title: "All users and global admins"
}
const _hoisted_29 = { class: "fg-color-blue" }
const _hoisted_30 = { class: "fg-color-blue" }
const _hoisted_31 = { class: "fg-color-blue" }
const _hoisted_32 = {
  class: "row",
  style: {"margin-bottom":"40px"}
}
const _hoisted_33 = ["href"]
const _hoisted_34 = {
  class: "col-md-2 text-center fg-color-blue",
  title: "Only users who are not locked"
}
const _hoisted_35 = { class: "col-md-2 text-center fg-color-blue" }
const _hoisted_36 = { class: "col-md-2 text-center fg-color-blue" }
const _hoisted_37 = ["href"]
const _hoisted_38 = { class: "col-md-2 text-center fg-color-blue" }

import { ref, computed, onMounted } from 'vue'
    import { useRoute, useRouter } from 'vue-router'
    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'
    import { useOrganizationAdminDetailsQueryV1 } from '@Organizations/OrganizationUnits/queries-vue-composables'
    import { useCurrentUserQueryV1 } from '@Organizations/Users/queries-vue-composables'

    // ---------------- route ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardPage',
  setup(__props) {

    const route = useRoute()
    const router = useRouter()

    const tid = computed(() => Number(route.params.tid))

    // ---------------- local state ----------------

    const searchPhrase = ref('')

    // ---------------- queries / commands ----------------

    const {
        modelOrganizationAdminDetailsQueryV1: organizationAdminDetails,
        runOrganizationAdminDetailsQueryV1
    } = useOrganizationAdminDetailsQueryV1(tid)

    const {
        runCurrentUserQueryV1,
        modelCurrentUserQueryV1: currentUserDetails
    } = useCurrentUserQueryV1(false, false, true)

    // ---------------- lifecycle ----------------

    onMounted(() =>
    {
        document.title = 'Admin dashboard'
        runCurrentUserQueryV1()
        runOrganizationAdminDetailsQueryV1()
    })

    // ---------------- handlers ----------------

    function handleSearch()
    {
        if (searchPhrase.value.length >= 2)
        {
            router.push(`/admin/organizations/search/${tid.value}/${searchPhrase.value}`)
        }
    }


    // ---------------- computed (UI-facing) ----------------

    const organizationName = computed(() => organizationAdminDetails.value?.OrganizationName)
    const organizationDescription = computed(() => organizationAdminDetails.value?.OrganizationDescription)
    const systemAdminEmail = computed(() => organizationAdminDetails.value?.SystemAdminEmail)
    const numberOfWorkspaces = computed(() => organizationAdminDetails.value?.NumberOfWorkspaces)
    const numberOfPortfolios = computed(() => organizationAdminDetails.value?.NumberOfPortfolios)
    const numberOfProjects = computed(() => organizationAdminDetails.value?.NumberOfProjects)
    const numberOfAccountRequests = computed(() => organizationAdminDetails.value?.NumberOfAccountRequests)
    const numberOfUsers = computed(() => organizationAdminDetails.value?.NumberOfUsers)
    const numberOfLockedUsers = computed(() => organizationAdminDetails.value?.NumberOfLockedUsers)
    const numberOfActiveUsers = computed(() => (numberOfUsers.value ?? 0) - (numberOfLockedUsers.value ?? 0))
    const numberOfGlobalAdmins = computed(() => organizationAdminDetails.value?.NumberOfGlobalAdmins)
    const numberOfServiceAccounts = computed(() => organizationAdminDetails.value?.NumberOfServiceAccounts ?? 0)
    const numberOfActiveSessions = computed(() => organizationAdminDetails.value?.NumberOfActiveSessions)
    const numberOfAccessLinks = computed(() => organizationAdminDetails.value?.NumberOfAccessLinks)
    const version = computed(() => organizationAdminDetails.value?.Version)

    const isSystemAdmin = computed(() => currentUserDetails.value?.IsSystemAdmin ?? false)
    const isGlobalAdmin = computed(() => currentUserDetails.value?.IsGlobalAdmin ?? false)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AdminNavigationV2, { tid: tid.value }, null, 8 /* PROPS */, ["tid"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", _hoisted_5, _toDisplayString(organizationName.value) + " organizational dashboard", 1 /* TEXT */),
          _createElementVNode("a", {
            href: `/#/admin/organizations/users/create/${tid.value}`,
            type: "button",
            class: "btn btn-link btn-sm"
          }, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("i", {
              class: "fa fa-user-plus",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createTextVNode(" Add user ", -1 /* CACHED */)
          ]))], 8 /* PROPS */, _hoisted_6),
          _createElementVNode("a", {
            href: `/#/admin/organizations/workspaces/create/${tid.value}`,
            type: "button",
            class: "btn btn-link btn-sm"
          }, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("i", {
              class: "fa fa-plus",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createTextVNode(" Add workspace ", -1 /* CACHED */)
          ]))], 8 /* PROPS */, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          (isSystemAdmin.value || isGlobalAdmin.value)
            ? (_openBlock(), _createElementBlock("a", _hoisted_9, [...(_cache[3] || (_cache[3] = [
                _createElementVNode("i", {
                  class: "fa fa-bank",
                  "aria-hidden": "true"
                }, null, -1 /* CACHED */),
                _createTextVNode(" Manage organizations ", -1 /* CACHED */)
              ]))]))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ]),
    _cache[14] || (_cache[14] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 30px"} }, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchPhrase).value = $event)),
            onKeyup: _withKeys(handleSearch, ["enter"]),
            class: "form-control form-control-lg",
            type: "search",
            placeholder: "Type to search for user, workspace or portfolio in your organization..."
          }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
            [_vModelText, searchPhrase.value]
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("button", {
              onClick: handleSearch,
              class: "btn btn-outline-secondary",
              type: "button",
              style: {"width":"60px"},
              disabled: searchPhrase.value.length<=1
            }, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("i", {
                class: "fa-solid fa-magnifying-glass",
                "aria-hidden": "true"
              }, null, -1 /* CACHED */)
            ]))], 8 /* PROPS */, _hoisted_14)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("h5", _hoisted_19, _toDisplayString(organizationName.value), 1 /* TEXT */),
              _createElementVNode("h6", _hoisted_20, "System admin: " + _toDisplayString(systemAdminEmail.value), 1 /* TEXT */),
              _createElementVNode("h6", _hoisted_21, "Version: " + _toDisplayString(version.value), 1 /* TEXT */),
              _createCommentVNode("<h6 class=\"card-subtitle mb-2 text-muted\">Organization admin: janusz@transparentchoice.com</h6>"),
              _createElementVNode("p", _hoisted_22, _toDisplayString(organizationDescription.value), 1 /* TEXT */),
              _createCommentVNode("<a :href=\"`/#/organizations/${id}`\" class=\"card-link\" target=\"_blank\">Dashboard</a>"),
              _createElementVNode("a", {
                href: `/#/admin/organizations/manage/${tid.value}`,
                class: "card-link"
              }, "Manage", 8 /* PROPS */, _hoisted_23),
              _createElementVNode("a", {
                href: `/#/admin/organizations/manage/branding/${tid.value}`,
                class: "card-link"
              }, "Branding", 8 /* PROPS */, _hoisted_24),
              _createElementVNode("a", {
                href: `/#/admin/organizations/manage/sso/${tid.value}`,
                class: "card-link"
              }, "SSO", 8 /* PROPS */, _hoisted_25)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("table", _hoisted_27, [
            _cache[9] || (_cache[9] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { colspan: "2" }, "Usage stats"),
                _createCommentVNode("<th class=\"text-right\"><a href=\"/\">Send report</a></th>")
              ])
            ], -1 /* CACHED */)),
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[5] || (_cache[5] = _createElementVNode("th", { scope: "row" }, "Users", -1 /* CACHED */)),
                _createElementVNode("td", _hoisted_28, _toDisplayString(numberOfUsers.value), 1 /* TEXT */)
              ]),
              _createElementVNode("tr", null, [
                _cache[6] || (_cache[6] = _createElementVNode("th", { scope: "row" }, "Workspaces", -1 /* CACHED */)),
                _createElementVNode("td", _hoisted_29, _toDisplayString(numberOfWorkspaces.value), 1 /* TEXT */)
              ]),
              _createElementVNode("tr", null, [
                _cache[7] || (_cache[7] = _createElementVNode("th", { scope: "row" }, "Portfolios", -1 /* CACHED */)),
                _createElementVNode("td", _hoisted_30, _toDisplayString(numberOfPortfolios.value), 1 /* TEXT */)
              ]),
              _createElementVNode("tr", null, [
                _cache[8] || (_cache[8] = _createElementVNode("th", { scope: "row" }, "Projects", -1 /* CACHED */)),
                _createElementVNode("td", _hoisted_31, _toDisplayString(numberOfProjects.value), 1 /* TEXT */)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", {
          class: _normalizeClass(["col-md-2 text-center", numberOfAccountRequests.value > 0 ? 'fg-color-orange' : 'fg-color-blue'])
        }, [
          _createElementVNode("h1", null, _toDisplayString(numberOfAccountRequests.value), 1 /* TEXT */),
          _createElementVNode("a", {
            href: `/#/admin/organizations/users/requests/${tid.value}`,
            class: _normalizeClass(numberOfAccountRequests.value > 0 ? 'fg-color-orange' : 'fg-color-blue')
          }, " Account requests ", 10 /* CLASS, PROPS */, _hoisted_33)
        ], 2 /* CLASS */),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("h1", null, _toDisplayString(numberOfActiveUsers.value), 1 /* TEXT */),
          _cache[10] || (_cache[10] = _createElementVNode("span", null, "Active Users", -1 /* CACHED */))
        ]),
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("h1", null, _toDisplayString(numberOfGlobalAdmins.value), 1 /* TEXT */),
          _cache[11] || (_cache[11] = _createElementVNode("span", null, "Global admins", -1 /* CACHED */))
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("h1", null, _toDisplayString(numberOfServiceAccounts.value), 1 /* TEXT */),
          _createElementVNode("a", {
            href: `/#/admin/organizations/users/service-accounts/${tid.value}`,
            class: "fg-color-blue"
          }, " Service accounts ", 8 /* PROPS */, _hoisted_37)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["col-md-2 text-center", numberOfLockedUsers.value > 0 ? 'fg-color-red' : 'fg-color-blue'])
        }, [
          _createElementVNode("h1", null, _toDisplayString(numberOfLockedUsers.value), 1 /* TEXT */),
          _cache[12] || (_cache[12] = _createElementVNode("span", null, "Locked users", -1 /* CACHED */))
        ], 2 /* CLASS */),
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("h1", null, _toDisplayString(numberOfActiveSessions.value), 1 /* TEXT */),
          _cache[13] || (_cache[13] = _createElementVNode("span", null, "Sessions", -1 /* CACHED */))
        ])
      ])
    ])
  ]))
}
}

})